import { useIsMobile } from '@/hooks/useIsMobile';
import { useRouter } from '@/i18n/routing';
import openModal from '@/modals/utils/openModal';
import { useUserMeQuery } from '@/queries/user/user.queries';

export const useOpenScratchCard = () => {
  const isMobile = useIsMobile();
  const router = useRouter();
  const { data: user } = useUserMeQuery();

  return (rewardGroupId: string) => {
    if (!user?.id) {
      return;
    }
    if (isMobile) {
      router.push(`/scratch-card?rewardGroupId=${rewardGroupId}&userId=${user.id}`);
    } else {
      openModal('scratch-card', { rewardGroupId, userId: user.id });
    }
  };
};
